import type { MonthNames } from "dayjs";

export const capitalizeMonth = (monthName: MonthNames) => {
  return monthName.toString().at(0)?.toUpperCase() + monthName.toString().slice(1);
};

export const capitalizeString = (input: string) => {
  return input.at(0)?.toUpperCase() + input.slice(1);
};
